import React, {useEffect, useState} from "react";
import {getTermsByCourse, getTermsByCourseAndKeyword} from "../../services/TermRepository";
import {Link, useOutletContext, useParams} from "react-router-dom";
import {Pagination} from "../../components/navigation/Pagination";
import {SimpleGrid} from "../../components/SimpleGrid";
import {IoSearch} from "react-icons/io5";
import {BsCardText} from "react-icons/bs";
import {FaCircleArrowRight} from "react-icons/fa6";


export function Terms(props) {

    const params = useParams();
    const [terms, setTerms] = useState([]);
    const [page, setPage] = useState(0);
    const [pageNum, setPageNum] = useState(5);
    const [searchKey, setSearchKey] = useState("");
    const {courseId} = useOutletContext();

    useEffect(() => {
        getTermsByCourse(courseId, page).then(result => {
            setTerms(result.content ?? []);
            setPageNum(result.totalPages);
        }).catch(error => console.log(error))
    }, [page]);


    function filteredTerms() {
        return terms.filter(item => item.term.toLowerCase().startsWith(searchKey.toLowerCase()));
    }

    function searchForTerms() {
        getTermsByCourseAndKeyword(courseId, 0, searchKey).then(result => {
            setTerms(result.content);
            setPageNum(result.totalPages);
        }).catch(error => console.log(error))
    }

    return (
        <div>
            <Link to={"/terms/flashcards/"+courseId} className={"btn btn-warning d-flex align-items-center text-decoration-none mb-3"} style={{width:"fit-content"}}>
                <label>Øv deg på begreper</label>
                <BsCardText size={24} className={"ms-2"}/>
                <FaCircleArrowRight size={24} className={"ms-2 "}/>
            </Link>
            <div className={"row px-3"}>
                <input className={"form-control col"} type={"text"} placeholder={"Søk etter begrep"} value={searchKey} onChange={(e) => setSearchKey(e.target.value)}/>
                <button className={"col-2 btn btn-primary text-white ms-2"} onClick={() => searchForTerms()}>
                    <IoSearch size={24} className={"me-2"}/>
                    <label>Søk</label>
                </button>
            </div>
            <div className={"mb-3"}>

                <SimpleGrid rowSize={3} fill={true} margin={2}>
                    {
                        terms.map(term => (
                            <div className={"border bg-white rounded m-2 p-3"} style={{minHeight:"100%"}}>
                                <h5 className={"fw-bold"}>{term.term}</h5>
                                <p className={""}>{term.definition}</p>
                            </div>
                        ))
                    }
                </SimpleGrid>
            </div>

            <Pagination selected={page} select={setPage} pages={pageNum}></Pagination>
        </div>
    );




}